import { render, staticRenderFns } from "./MainAlertMessage.vue?vue&type=template&id=490f475c&scoped=true&"
import script from "./MainAlertMessage.vue?vue&type=script&lang=js&"
export * from "./MainAlertMessage.vue?vue&type=script&lang=js&"
import style0 from "./MainAlertMessage.vue?vue&type=style&index=0&id=490f475c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f475c",
  null
  
)

export default component.exports